<template>
  <div id="app">
    <tool-box-main />
    <el-container>
      <el-aside class="body-side">
        <div class="left-top-logo border-bottom-line">
          <img
            src="@/assets/img/logo.png"
            style="width: 120px;cursor: pointer;"
            @click="$router.push({ name: 'Index' })"
          >
        </div>
        <div
          class="side-menu-box border-bottom-line"
          style="height: 600px;"
        >
          <side-menu
            :menu-data="menu"
            style="z-index: 9999;"
          />
        </div>
        <div class="bottom-contact-info">
          <div style="color: #8F8F8F; height: 60px;">
            <el-popover
              ref="popover"
              placement="right"
              width="260"
              trigger="hover"
            >
              <template>
                <div style="display: flex; justify-content: space-around;">
                  <div style="text-align: center;">
                    <img
                      style="width: 120px"
                      src="@/assets/img/qrcode-zyzlcx.jpg"
                    >
                    <div style="font-size: 12px">
                      卓越质量创新
                    </div>
                  </div>

                  <div style="text-align: center">
                    <img
                      style="width: 120px"
                      src="@/assets/img/201711085a026acc842db.jpg"
                    >
                    <div style="font-size: 12px">
                      四川标准化服务平台
                    </div>
                  </div>
                </div>
              </template>
            </el-popover>
            <el-button
              v-popover:popover
              type="text"
            >
              <font-awesome-icon
                style="font-size: 22px"
                icon="qrcode"
              />
            </el-button>
          </div>
          <div style="text-align: center;color: #D8D8D8;font-size: 14px">
            <p>四川万豪恒达信息科技有限公司</p>
            <p>
              <a
                href="https://beian.miit.gov.cn/"
                target="_blank"
                style="color: inherit;text-decoration: none"
              >蜀ICP备19021297号</a>
            </p>
          </div>
        </div>
      </el-aside>
      <el-main class="body-main">
        <div style="min-height: 800px">
          <router-view />
        </div>
        <page-footer />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import SideMenu from '@/components/menu/SideMenu.vue';
import ToolBoxMain from '@/components/sideContactToolBox/ToolBoxMain.vue';
import PageFooter from '@/components/PageFooter/PageFooter.vue';
import { menu } from '@/constant';

export default {
  name: 'App',
  components: {
    PageFooter,
    ToolBoxMain,
    SideMenu,
  },
  data() {
    return {
      menu,
    };
  },
};
</script>

<style lang="less">
html{
  min-width: 1256px;
}
body{
  margin: 0;
}
#app {
  img {
    max-width: 100% !important;
  }
  font-family: "PingFang SC", "Microsoft YaHei", Arial, serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #fcfcfc;

  .body-side {
    width: 200px!important;
    position: fixed;
    overflow: unset;
    z-index: 9;
    background: url("assets/img/side-bg.png");
    height: 100%;
    background-size: cover;
  }
  .body-main{
    margin-left: 199px;
    width: calc(100% - 200px);
    padding: 0
  }
  .left-top-logo{
    padding: 36px 0;
    margin-bottom: 20px;
    text-align: center;
  }
  .border-bottom-line{
    border-bottom: 1px solid #3E3E3E;
  }

  .bottom-contact-info{
    text-align: center;
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 160px;
  }
}
</style>
